export const trackingEvents = {
  CLICK_FLIGHT_SELECTOR: action => {
    return {
      category: 'voluntary-change_lc',
      label: `change-lc_click:${action}_pag:voch_lc`,
      action: 'change-your-trip_lc'
    };
  },
  CLICK_CHANGE_TRIP_LC: action => {
    return {
      category: 'voluntary-change_lc_summary',
      label: `change-lc_click:${action}_pag:voch_summary`,
      action: 'change-your-trip_lc'
    };
  },
  CLICK_GUIDE: action => {
    return {
      category: 'voluntary-change_lc_guide',
      label: `change-lc_click:${action}_pag:voch_guide`,
      action: 'change-your-trip_lc'
    };
  }
};
export const trackLabelTypes = {
  back: 'back',
  backToMenu: 'back-to-menu',
  backToBooking: 'back-to-booking',
  selectFlight: 'select-flight',
  selectFlightPNR: 'select-flight-PNR',
  continue: 'continue',
  seeTripGuide: 'voch-guide',
  openEF: 'open-ef',
  copyPnr: 'copy-pnr',
  copyEmail: 'copy-email',
  airlineWebsite: 'airline-website',
  contact: 'contact',
  contactUs: 'contact-us',
  clickAirlineSite: 'airline-website'
};